import React from 'react'

const Manage_staf = () => {
  return (
    <div>Manage_staf</div>
  )
}

export default Manage_staf